import React from 'react';
import { Link } from 'react-router-dom';
import mantisWhiteLogo from '../Assets/img/mantisWhiteLogo2.png';
import sandyLogo from '../Assets/img/sandyBlackLogo.png';
import { isSandy } from '../config';
import { Mail, Phone, ShieldCheck, FileText, MapPin, Clock, ArrowUpRight } from 'lucide-react';

const PublicFooter = () => {
  return (
    <footer className="bg-slate-900 text-slate-300 mt-16 border-t-2 border-orange-500 relative overflow-hidden">
      {/* Subtle Background Glows */}
      <div className="absolute top-0 right-1/4 w-96 h-96 rounded-full bg-orange-500/5 blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-0 left-10 w-80 h-80 rounded-full bg-amber-500/5 blur-3xl pointer-events-none"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 relative z-10">
        
        {/* Main Footer Grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 lg:gap-12 pb-12 border-b border-slate-800">
          
          {/* Column 1: Brand & Bio (5 cols) */}
          <div className="md:col-span-5 space-y-4 text-left">
            <div className="flex items-center gap-3">
              <img
                src={isSandy ? sandyLogo : mantisWhiteLogo}
                alt="Mantis Logo"
                className="h-8 sm:h-9 w-auto object-contain"
              />
            </div>

            <div className="flex items-center gap-2 text-xs text-slate-400 pt-1">
              <MapPin className="w-3.5 h-3.5 text-orange-500 flex-shrink-0" />
              <span>Bogotá D.C., Colombia &bull; NIT 901712099 - 2</span>
            </div>
          </div>

          {/* Column 2: Marco Legal (3 cols) */}
          <div className="md:col-span-3 space-y-3.5 text-left">
            <h4 className="text-xs font-bold uppercase tracking-wider text-white flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-orange-500"></span>
              <span>Marco Legal</span>
            </h4>

            <ul className="space-y-2.5 text-xs sm:text-sm">
              <li>
                <Link
                  to="/data-treatment-policies"
                  className="group inline-flex items-center gap-2 text-slate-400 hover:text-white transition-colors"
                >
                  <ShieldCheck className="w-4 h-4 text-orange-500/80 group-hover:text-orange-400 transition-colors" />
                  <span>Tratamiento de Datos</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/terms-and-conditions"
                  className="group inline-flex items-center gap-2 text-slate-400 hover:text-white transition-colors"
                >
                  <FileText className="w-4 h-4 text-orange-500/80 group-hover:text-orange-400 transition-colors" />
                  <span>Términos y Condiciones</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Contacto y Soporte (4 cols) */}
          <div className="md:col-span-4 space-y-3.5 text-left">
            <h4 className="text-xs font-bold uppercase tracking-wider text-white flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-orange-500"></span>
              <span>Atención Corporativa</span>
            </h4>

            <ul className="space-y-2.5 text-xs sm:text-sm text-slate-400">
              <li>
                <a
                  href="mailto:jairo@mantisapp.co"
                  className="group inline-flex items-center gap-2 hover:text-white transition-colors"
                >
                  <Mail className="w-4 h-4 text-orange-500/80 group-hover:text-orange-400 transition-colors" />
                  <span>jairo@mantisapp.co</span>
                  <ArrowUpRight className="w-3 h-3 opacity-50 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
                </a>
              </li>
              <li>
                <a
                  href="tel:+573154308744"
                  className="group inline-flex items-center gap-2 hover:text-white transition-colors"
                >
                  <Phone className="w-4 h-4 text-orange-500/80 group-hover:text-orange-400 transition-colors" />
                  <span>+57 315 430 8744</span>
                </a>
              </li>
              <li className="flex items-center gap-2 text-slate-400 text-xs pt-0.5">
                <Clock className="w-4 h-4 text-orange-500/80 flex-shrink-0" />
                <span>Lun - Vie: 8:00 AM - 6:00 PM</span>
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom Copyright Row */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-400 text-center sm:text-left">
          <p>
            &copy; {new Date().getFullYear()} Mantis App S.A.S. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-2 text-slate-400">
            <span>Seguridad &bull; Trazabilidad &bull; Inteligencia</span>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default PublicFooter;
